import type { UserPremiumType } from "../../types/experiment";
import { TagInput } from "../Shared/TagInput";

interface Props {
  value: UserPremiumType;
  onChange: (value: UserPremiumType) => void;
}

export function UserPremiumTypeFilter({ value, onChange }: Props) {
  return (
    <TagInput
      label="Premium Types"
      tags={value.premium_types.map(String)}
      onChange={(premium_types) => onChange({ ...value, premium_types: premium_types.map(Number) })}
      placeholder="e.g. 0, 1, 2"
      inputType="number"
    />
  );
}
